import { Metadata } from "@/types/params.types";

export const SALES_DASHBOARD_METADATA: Metadata = {
  salesDashboardTitle: "Dashboard de Vendas",
  salesDashboardDescription: "Página de dashboard de vendas",
};

import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type SalesDashboardMessages = SidebarMessages &
  ActionButtonMessages & {
    pageTitle: string;
    breadCrumbTitle: string;

    // Info Cards
    ordersTitle: string;
    salesTitle: string;
    averageTicketTitle: string;

    // Charts
    monthlySalesEvolutionTitle: string;

    // Table
    bestSellingProductsTitle: string;
    productColumn: string;
    valueColumn: string;
    ordersLabel: string;
    orderLabel: string;

    // Date Range Options
    today: string;
    currentMonth: string;
    currentYear: string;
    lastDay: string;
    lastMonth: string;
    lastYear: string;

    //Error messages
    notFoundAlt: string;
    errorToLoad: string;
    noDataMessage: string;
    noDataTitle: string;
  };

export const SALES_DASHBOARD_MESSAGES: SalesDashboardMessages = {
  pageTitle: "Vendas",
  breadCrumbTitle: "Dashboard",

  // Info Cards
  ordersTitle: "Pedidos",
  salesTitle: "Vendas",
  averageTicketTitle: "Ticket Médio",

  // Charts
  monthlySalesEvolutionTitle: "Evolução mensal de vendas",

  // Table
  bestSellingProductsTitle: "Produtos mais vendidos no mês",
  productColumn: "Produto",
  valueColumn: "Valor",
  ordersLabel: "pedidos",
  orderLabel: "pedido",

  // Date Range Options
  today: "Hoje",
  currentMonth: "Mês atual",
  currentYear: "Ano atual",
  lastDay: "Último dia",
  lastMonth: "Último mês",
  lastYear: "Último ano",

  //Error messages
  errorToLoad: "Erro ao carregar dados",
  notFoundAlt: "Dado não encontrado",
  noDataMessage: "Não há dados disponíveis para o período selecionado",
  noDataTitle: "Nenhum dado encontrado",

  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};

export default SALES_DASHBOARD_MESSAGES;
